// extracted by mini-css-extract-plugin
export var assigneeBadge = "_o4-0";
export var assigneeDetails = "_o4-1";
export var assigneeInfo = "_o4-2";
export var dropdownContainer = "_o4-4";
export var dropdownImage = "_o4-5";
export var editAssigneeInfo = "_o4-3";
export var editAssigneeModalContainer = "_o4-6";
export var hidden = "_o4-8";
export var input = "_o4-7";